<template>
	<div class="container page">
		<van-nav-bar :title="this.vod_name" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="right">
			<van-pull-refresh border="false" class="list-wrapper" v-model="isLoading" @refresh="onRefresh">
				<van-grid :column-num="2" :gutter="10">
					<van-grid-item @click="profile(v)" v-for="(v, k) in datalist" :key="k" class="girl-grid-item">
						<van-image class="game_item_img" :src="v.img_url">
							<template v-slot:loading>
								<van-loading type="circular" />
							</template>
						</van-image>
						<span class="rig-name">{{ v.xuanfei_name }}</span>
						<span v-if="v.address" class="rig-address">{{ v.address }}</span>
						<span v-if="isLocked(v)" class="grid-vip-lock">VIP</span>
					</van-grid-item>
				</van-grid>
				<div v-if="!isLoading && datalist.length === 0" class="empty-list">
					{{ $t('region_empty') }}
				</div>
			</van-pull-refresh>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			vod_name: '',
			isLoading: false,
			userVip: 0,
			datalist: []
		};
	},
	methods: {
		back() {
			this.$router.push({ path: '/Home' });
		},
		onRefresh() {
			setTimeout(() => {
				this.$toast(this.$t("reservation.refresh"));
				this.isLoading = false;
				this.getxuanfeilist();
			}, 500);
		},
		isLocked(item) {
			return Number(item.vip_only) === 1 && this.userVip < 1;
		},
		profile(item) {
			if (this.isLocked(item)) {
				this.$toast(this.$t('vip_required'));
				return;
			}
			this.$router.push({ path: '/profile?id=' + item.id + '&name=' + this.vod_name + '&adsid=' + this.$route.query.id });
		},
		getUserInfo() {
			if (!localStorage.getItem('token')) return;
			this.$http({ method:'get', url:'user_info' }).then(res => {
				if (res.code === 200 && res.data) this.userVip = Number(String(res.data.vip || '0').replace(/[^0-9]/g,'')) || 0;
			});
		},
		getxuanfeilist() {
			this.$http({
				method: 'get',
				url: 'xuanfeilist',
				data: { id: this.$route.query.id }
			}).then(res => {
				const locale = this.$i18n.locale || localStorage.getItem('lang') || 'ja';
				this.datalist = (res.data || []).map(item => {
					item.xuanfei_name = this.common.pickLangText(item.xuanfei_name, ',', locale);
					return item;
				});
			});
		}
	},
	created() {
		const rawName = this.$route.query.name || '';
		this.vod_name = rawName || this.$t('concubine.concubine');
		this.getUserInfo();
		this.getxuanfeilist();
	}
};
</script>

<style scoped>
.right {
	margin-top: 10px;
}
::v-deep .van-grid-item__content--center {
	border-radius: 15px;
	padding: 0;
	height: auto;
}
::v-deep .van-image__img {
	border-radius: 10px;
	padding: 15px;
}
.rig-name {
	width: 100%;
	height: 60px;
	line-height: 60px;
	margin-top: 10px;
	background-color: #f7f7f7;
	border-radius: 0 0 15px 15px;
	font-size: 15px;
	padding-left: 10px;
}
.girl-grid-item { position: relative; }
.grid-vip-lock {
	position: absolute;
	top: 15px;
	right: 15px;
	padding: 4px 10px;
	border-radius: 12px;
	background: rgba(20,20,20,.85);
	color: #f2c79f;
	font-weight: 700;
}
.rig-address {
	display: block;
	width: 100%;
	padding: 0 10px 12px;
	box-sizing: border-box;
	color: #8c8c8c;
	font-size: 13px;
	background-color: #f7f7f7;
	text-align: left;
}
.empty-list {
	padding: 80px 20px;
	text-align: center;
	color: #aaa;
	font-size: 16px;
}
</style>
